{
  "labels": {
    "getFullAccess": "קבל גישה למערכת המלאה",
    "getFullAccess2": "לחץ כאן לחשיפת המלאי",
    "filters": "מסננים",
    "backTo": "חזרה אל",
    "back": "חזור",
    "backToMain": "חזרה לתצוגה",
    "noReferrer": "אין דף קודם לחזור אליו",
    "rooms": "חדרים",
    "interactiveDescription": "בואו לפגוש את הפרויקט בחוויה אינטראקטיבית",
    "lowerCaseRooms": "{{v, optional}} חדרים",
    "area": "שטח",
    "cancel": "בטל",
    "apply": "החל",
    "floors": "קומה",
    "floor": "קומה {{v, optional}}",
    "balcony": "מרפסת",
    "liked": "אהבת",
    "lowerCaseBalcony": "מרפסת {{v, optional}} מ\"ר",
    "buildings": "בניינים",
    "apt": "דירה {{v, optional}}",
    "squareMeters": "מטרים רבועים",
    "yourName": "שם מלא",
    "emailAddress": "כתובת אימייל",
    "phoneNumber": "מספר טלפון",
    "contactAgent": "צרו קשר עכשיו",
    "contactUsTab" : "צרו קשר",
    "leadFormConsentStart": "אני מסכים/ה שימוש בפרטיי לפי",
    "leadFormConsentPrivacy": "מדיניות הפרטיות",
    "leadFormConsentEula": ",תקנון האתר",
    "leadFormConsentEnd": "ומאשר/ת קבלת דיוור מקבוצת אפריקה ישראל",
    "or": "או",
    "showcase": "סביבה",
    "theProject": "פרויקט",
    "exploreProject": "בואו לפגוש את הפרויקט בחוויה אינטראקטיבית",
    "exploreMap": "לחצו כאן וגלו מיקומים קרובים לפרויקט",
    "promotion": "קידום",
    "viewAptIn3D": "צפו בדירה בתלת מימד",
    "3Dtour": "סיור 3D",
    "3Dtour1": "סיורי תלת מימד",
    "3Dtours": "סיורים ב-3D",
    "balconyView": "נוף מרפסת",
    "floorPlan": "תוכניות דירה",
    "inventory": "סוגי דירות",
    "inventory2": "מלאי",
    "inventory3": "טיפוסי דירות",
    "inventorySectionTitle": "יחידות למכירה בפרויקט",
    "inventorySectionTitleRent": "יחידות להשכרה בפרויקט",
    "documents": "מסמכים",
    "share": "שיתוף",
    "shareLink": "שיתוף קישור לפרויקט",
    "shareLocation": "שתף מיקום נוכחי",
    "continue": "המשך",
    "m2": "{{v, optional}} מ\"ר",
    "fromM2": "מ-{{v}} מ\"ר",
    "all": "הכל",
    "sale": "מבצע",
    "building": "בניין {{v, optional}}",
    "statusAvailable": "זמין",
    "3D": "3D",
    "poweredBy": "מופעל על ידי",
    "explore": "הצגת דירה",
    "explore3DApartment": "צפו בדירה בתלת מימד",
    "backToBuilding": "חזרה לבניין",
    "apartmentSpecifications": "מפרט הדירה",
    "applyNow": "צרו קשר עכשיו",
    "favorite": "מועדפים",
    "aptDetails": "פרטי דירה",
    "env": "סביבה",
    "inv": "מלאי",
    "info": " פרויקט",
    "discount": "מבצע",
    "offersAvailable": "להצעות משתלמות בפרויקט",
    "interactiveView": "חוויה אינטראקטיבית",
    "360view": "סיור תלת מימדי 360°",
    "apartmentsAvailable": "{{v}} זמינים",
    "checkInMinutes": "מידע על אזור הפרויקט",
    "timeline": "ציר זמן של הפרויקט",
    "progressMap": "מפת התקדמות",
    "about": "על הפרויקט",
    "interactive": "פנורמה",
    "interactive2": "חוויה אינטראקטיבית",
    "promotions": "הצעות מיוחדות",
    "specifications": "מפרטי הפרויקט",
    "gallery": "גלריה",
    "map": "מפה",
    "nearbyPlaces": "מיקומים קרובים",
    "transport": "תחבורה",
    "shopping": "קניות",
    "educations": "חינוך",
    "roadmap": "מפה",
    "satellite": "לוויין",
    "library": "ספרייה",
    "preschool": "גני ילדים",
    "primary_school": "בית ספר יסודי",
    "school": "בית ספר",
    "secondary_school": "תיכון",
    "university": "אוניברסיטה",
    "asian_grocery_store": "חנות מצרכים אסייתית",
    "auto_parts_store": "חנות חלפים לרכב",
    "bicycle_store": "חנות אופניים",
    "book_store": "חנות ספרים",
    "butcher_shop": "חנות בשר",
    "cell_phone_store": "חנות טלפונים סלולריים",
    "clothing_store": "חנות בגדים",
    "convenience_store": "חנות נוחות",
    "department_store": "חנות כלבו",
    "discount_store": "חנות למוצרים זולים",
    "drugstore": "בית מרקחת",
    "electronics_store": "חנות אלקטרוניקה",
    "food_store": "חנות מזון",
    "furniture_store": "חנות רהיטים",
    "gift_shop": "חנות מתנות",
    "grocery_store": "חנות מכולת",
    "hardware_store": "חנות חומרי בניין",
    "home_goods_store": "חנות מוצרים לבית",
    "home_improvement_store": "חנות שיפוצים ושדרוגים לבית",
    "jewelry_store": "חנות תכשיטים",
    "liquor_store": "חנות אלכוהול",
    "market": "שוק",
    "pet_store": "חנות חיות מחמד",
    "shoe_store": "חנות נעליים",
    "shopping_mall": "קניון",
    "sporting_goods_store": "חנות ספורט",
    "store": "חנות",
    "supermarket": "סופרמרקט",
    "warehouse_store": "חנות הכל לבית",
    "wholesaler": "סיטונאי",
    "airport": "נמל תעופה",
    "airstrip": "מסלול טיסה",
    "bus_station": "תחנת אוטובוס",
    "bus_stop": "תחנה לאוטובוס",
    "ferry_terminal": "טרמינל מעבורות",
    "heliport": "מנחת מסוקים",
    "international_airport": "נמל תעופה בינלאומי",
    "light_rail_station": "תחנת רכבת קלה",
    "park_and_ride": "חניון עם תחבורה ציבורית",
    "subway_station": "תחנת רכבת תחתית",
    "taxi_stand": "תחנת מוניות",
    "train_station": "תחנת רכבת",
    "transit_depot": "תחנת מעבר",
    "transit_station": "תחנת מעבר",
    "truck_stop": "תחנת משאיות",
    "learnMore": "למידע נוסף",
    "readMore": "קרא עוד",
    "readLess": "קרא פחות",
    "showMore": "הצג עוד",
    "showLess": "קרא פחות",
    "seeMore": "ראה עוד",
    "parks": "פארקים",
    "hospitals": "בתי חולים",
    "restaurants": "מסעדות",
    "gyms": "חדרי כושר",
    "pharmacies": "בתי מרקחת",
    "entertainment": "בידור",
    "banks": "בנקים",
    "park": "פארק",
    "garden": "גינה",
    "national_park": "פארק לאומי",
    "botanical_garden": "גינה בוטנית",
    "picnic_ground": "מקום לפיקניק",
    "state_park": "פארק מדינה",
    "wildlife_park": "פארק טבע",
    "wildlife_refuge": "מקדש חיות בר",
    "hospital": "בית חולים",
    "restaurant": "מסעדה",
    "afghani_restaurant": "מסעדה אפגנית",
    "african_restaurant": "מסעדה אפריקאית",
    "american_restaurant": "מסעדה אמריקאית",
    "asian_restaurant": "מסעדה אסייתית",
    "barbecue_restaurant": "מסעדת ברביקיו",
    "brazilian_restaurant": "מסעדה ברזילאית",
    "breakfast_restaurant": "מסעדת ארוחת בוקר",
    "brunch_restaurant": "מסעדת ברנצ'",
    "buffet_restaurant": "מסעדת בופה",
    "chinese_restaurant": "מסעדה סינית",
    "dessert_restaurant": "מסעדת קינוחים",
    "fast_food_restaurant": "מסעדת אוכל מהיר",
    "fine_dining_restaurant": "מסעדה יוקרתית",
    "indian_restaurant": "מסעדה הודית",
    "indonesian_restaurant": "מסעדה אינדונזית",
    "italian_restaurant": "מסעדה איטלקית",
    "japanese_restaurant": "מסעדה יפנית",
    "mediterranean_restaurant": "מסעדה ים תיכונית",
    "mexican_restaurant": "מסעדה מקסיקנית",
    "middle_eastern_restaurant": "מסעדה מזרח תיכונית",
    "pizza_restaurant": "מסעדת פיצה",
    "ramen_restaurant": "מסעדת ראמן",
    "seafood_restaurant": "מסעדת מאכלי ים",
    "spanish_restaurant": "מסעדה ספרדית",
    "sushi_restaurant": "מסעדת סושי",
    "thai_restaurant": "מסעדה תאילנדית",
    "turkish_restaurant": "מסעדה טורקית",
    "vegan_restaurant": "מסעדה טבעונית",
    "vegetarian_restaurant": "מסעדה צמחונית",
    "vietnamese_restaurant": "מסעדה ויאטנמית",
    "steak_house": "סטייק האוס",
    "gym": "חדר כושר",
    "fitness_center": "מרכז כושר",
    "sports_club": "מועדון ספורט",
    "sports_complex": "מרכז ספורט",
    "sports_activity_location": "מיקום לפעילויות ספורט",
    "athletic_field": "מגרשי ספורט",
    "pharmacy": "בית מרקחת",
    "adventure_sports_center": "מרכז ספורט אתגרי",
    "amphitheatre": "אמפיתיאטרון",
    "amusement_center": "מרכז בידור",
    "amusement_park": "פארק שעשועים",
    "aquarium": "אקווריום",
    "banquet_hall": "אולם אירועים",
    "barbecue_area": "אזור ברביקיו",
    "bowling_alley": "מסלול בולינג",
    "casino": "קזינו",
    "childrens_camp": "מחנה ילדים",
    "comedy_club": "מועדון קומדיה",
    "cycling_park": "פארק אופניים",
    "dance_hall": "אולם ריקודים",
    "event_venue": "מקום אירועים",
    "ferris_wheel": "גלגל ענק",
    "hiking_area": "אזור טיולים",
    "karaoke": "קריוקי",
    "movie_theater": "קולנוע",
    "night_club": "מועדון לילה",
    "opera_house": "בית אופרה",
    "philharmonic_hall": "היכל פילרמוני",
    "planetarium": "פלנטריום",
    "plaza": "כיכר",
    "roller_coaster": "רכבת הרים",
    "skateboard_park": "פארק סקייטבורד",
    "tourist_attraction": "אטרקציה תיירותית",
    "video_arcade": "ארקייד וידאו",
    "water_park": "פארק מים",
    "zoo": "גני חיות",
    "bank": "בנק",
    "atm": "כספומט",
    "coffee_shop": "בית קפה",
    "mapPage": "תצוגת מפה",
    "showcasePage": "תצוגת תלת מימד",
    "menu": "תפריט",
    "apartment": "דירה",
    "fromPrice": "מתחיל מ - ₪{{v}}",
    "moreInfo": "אני רוצה לקבל פרטים",
    "detailsSent": "הפרטים נשלחו",
    "noPriceSpecified": "לא צויין מחיר",
    "aptNumber": "דירה {{v}}",
    "aptWithRooms": "דירות {{v}} חדרים",
    "penthouseAptWithRooms": "פנטהאוז ({{v}} חדרים)",
    "type": "סוג הנכס",
    "price": "מחיר",
    "patio": "דירת גן",
    "ground": "קרקע",
    "studioLoft": "סטודיו/לופט",
    "cottage": "בית פרטי/קוטג'",
    "penthouse": "פנטהאוז / גג",
    "duplex": "דופלקס",
    "apartmentUnit": "יחידת דיור",
    "offices": "משרדים",
    "stores": "חנויות",
    "clinics": "קליניקות",
    "commercialWarehouses": "מחסנים",
    "commercialPlots": "מגרשים",
    "industrialStructures": "מבני תעשיה",
    "venues": "אולמות",
    "agriculturalPlots": "משק חקלאי/נחלה",
    "commercialGeneral": "כללי",
    "vacationApartments": "תיירות ונופש",
    "parkingPlaces": "חניה",
    "apartmentSwapping": "החלפת דירות",
    "plots": "מגרשים / קרקעות",
    "officeBuildings": "בניין משרדים",
    "businessesForSale": "עסקים למכירה",
    "parkingPlots": "חניון",
    "twofamilyDwelling": "דו-משפחתי",
    "general": "כללי",
    "sublet": "סאבלט",
    "residentialBuilding": "בניין מגורים",
    "warehouses": "מחסן",
    "estate": "משק חקלאי/נחלה",
    "trailers": "קראוון",
    "basementParterres": "מרתף/פרטר",
    "triplex": "טריפלקס",
    "auxiliaryPlots": "משק עזר",
    "basement": "מרתף",
    "studio": "סטודיו",
    "hotel": "בית מלון",
    "assistedLiving": "דיור מוגן",
    "jointWorkspace": "חלל עבודה משותף",
    "purchaseGroup": "קב' רכישה/זכות לנכס",
    "projectGallery": "גלריית הפרויקט",
    "showAllPhotos": "הצגת כל הצילומים",
    "startATour": "לחצו להתחלת סיור",
    "nowOnSale": "עכשיו במבצע",
    "forFurtherInfo": "למידע נוסף על הפרויקט",
    "forFurtherInfoIsYzer": "מחפשים דירה חדשה בסביבה?\nהשאירו פרטים ותקבלו יעוץ למציאת דירה",
    "submit": "שלחו פניה",
    "education": "מוסדות חינוך",
    "commercial": "מסחרי",
    "religion": "מוסדות",
    "time": "{{v}} דקות",
    "priceBy": {
      "total": "ללא",
      "m2": "למ\"ר"
    },
    "startingFromPerSquareMeters": "החל מ-₪{{v}} למ\"ר",
    "startingFromMoney": "החל מ-₪{{v}}",
    "onlyThreeDVisible": "במצב זה - רק דירות תלת מימד מוצגות.",
    "clickForFullList": "לחץ כאן לרשימה המלאה והתכונות.",
    "apartmentTypes": "טיפוסי דירות",
    "scheduleSystemDemo": "קבע פגישה להצגת המערכת",
    "scheduleSystemDemoDescription": "השאר פרטים לקביעת פגישה עם נציג מכירות, בה תקבלו מידע על הפרוייקט ותיחשפו למערכת התלת מימד המלאה",
    "bookMeeting": "קבעו פגישה עכשיו",
    "dummyApartmentsDisclaimer": "בהדמיה זו מוצגות דירות לדוגמא ולא מלאי הפרוייקט",
    "north": "צפון",
    "east": "מזרח",
    "south": "דרום",
    "west": "מערב",
    "callUsNow": "התקשרו אלינו עכשיו",
    "tapNumberBelow": "הקישו על המספר למטה כדי להתקשר אלינו ישירות. אנחנו כאן כדי לעזור לכם.",
    "noSms": "למספר זה לא ניתן לשלוח \"SMS\"",
    "showPhoneNumber": "הצג מספר טלפון",
    "zoomIn": "הגדל תצוגה",
    "zoomOut": "הקטן תצוגה",
    "resetZoom": "איפוס תצוגה",
    "lockedBuildingTooltipText": "בהדמיה זו מוצגות דירות לדוגמא ולא מלאי הפרוייקט",
    "lockedBuildingTooltipChip": "קבל גישה למערכת המלאה",
    "otherProjects": "קבלו מידע לגבי פרויקטים נוספים של החברה"
  },
  "time": {
    "day": "יום",
    "days": "ימים",
    "hour": "שעה",
    "hours": "שעות",
    "minute": "דקה",
    "minutes": "דקות",
    "second": "שנייה",
    "seconds": "שניות"
  },
  "info": {
    "foundApartments": "נמצאו {{count}} דירות",
    "penthausesLeft": "מבצעים מיוחדים לנדלניישן",
    "talkAndConsult": "כל הדירות במחירים מיוחדים ביריד הדירות החדשות של יד2",
    "messageSent": "ההודעה נשלחה!",
    "messageSentDescription": "ההודעה שלכם בדרך אלינו. ניצור עמכם קשר בקרוב!",
    "projectsOffersDescription": "קבל מידע על פרויקטים אחרים באזור",
    "requiredField": "אנא מלא את האזור הזה.",
    "consentRequired": "חובה לסמן את הצ׳ק בוקס על מנת להמשיך",
    "invalidEmail": "כתובת האימייל אינה תקינה.",
    "invalidPhone": "מספר הטלפון אינו תקין.",
    "failedToSendMessage": "נכשל בשליחת ההודעה",
    "greatChoice": "בחירה נהדרת! בוא נתחיל בבית החדש שלך",
    "greatChoiceDescription": "אתה צעד אחד קרוב יותר לביתך החדש. מלא את הפרטים שלך, והצוות שלנו ייצור איתך קשר עם הצעות בלעדיות ומידע נוסף.",
    "promotionsDescription": "מבצעים מיוחדים – הצעות לזמן מוגבל שיכולות להפוך את חלום הבית שלכם למציאות! השאירו פרטים ונחזור אליכם בהקדם",
    "promotionsLeadDescription": "שלח לנו הודעה בכדי לברר פרטים נוספים",
    "leadMessageSent": "ההודעה נשלחה בהצלחה!",
    "leadMessageThankyou": "תודה על פנייתך נציגנו יחזרו אליך בהקדם",
    "leadMessageExplore": "קבלו מידע לגבי פרויקטים נוספים באזור",
    "promotionalLabelDefault": "קבלו מידע לגבי פרויקטים נוספים באזור",
    "specificationsDescription": "מידע מפורט על חומרי בניין, גימורים, והתקנות באיכות גבוהה המיועדות לחיים מודרניים.",
    "inventoryDescription": "לצפייה בדירות הפרויקט",
    "aboutTheProject": "על הפרויקט",
    "aboutClient": "אודות החברה",
    "previewMessage": "זוהי תצוגה מקדימה. טפסים ורכיבים אינטראקטיביים לא יעבדו עד לאישור."
  },
  "specs": {
    "spec1": "פיתוח סביבתי ייחודי ושטחים ירוקים המשלבים אלמנטים של ספורט ולייף סטייל",
    "spec2": "מחסן פרטי לדירות נבחרות בחניון תת קרקעי",
    "spec3": "לובי יוקרתי וכפול",
    "spec4": "מועדון דיירים רב תכליתי, כולל מטבחון, עמדות טעינה ודלת יציאה לגינה",
    "spec5": "מעליות מפוארות ומהירות בשילוב נירוסטה ומראות",
    "spec6": "בניה ירוקה לפי תקן 5281",
    "spec7": "חניון תת קרקעי רחב ידיים",
    "spec8": "הכנה בבניין למערכת הטענה לרכבים חשמליים",
    "spec9": "מערכת חשמל - בית חכם - לשליטה בחלל המגורים: תאורה, תריס חשמלי, דוד ומיזוג אוויר",
    "spec10": "הכנה למערכת מיזוג מרכזית",
    "spec11": "חלונות בעלי זכוכית בידודית / טריפלקס בסלון וחדרי השינה",
    "spec12": "תריסים חשמליים בסלון וחדרי השינה",
    "spec13": "אינטרקום במעגל סגור עם מסך צבעוני",
    "spec14": "ריצוף גרניט פורצלן במידות {{v}}/{{v}} במבחר סדרות וגוונים",
    "spec15": "הכנה לחימום מים בגז",
    "spec16": "חימום מים סולארי/ משאבת חום",
    "spec17": "שקע חשמל וברז מים במרפסת שמש",
    "spec18": "דלת בטחון מעוצבת במבחר גוונים רב בריח או שו\"ע",
    "spec19": "מפסק מחליף בחדרי שינה",
    "spec20": "נקודות טלוויזיה, טלפון והכנה לתקשורת מחשבים בכל חדר",
    "spec21": "מרפסת שמש הכוללת מעקות אלומיניום מזוגג בשילוב זכוכית",
    "spec22": "חשמל תלת פאזי",
    "spec23": "משטחי עבודה אבן קיסר או שו\"ע במבחר דגמים וגוונים לבחירה",
    "spec24": "חיפוי קרמיקה - במבחר דגמים וגוונים לבחירה",
    "spec25": "כיור מטבח אקרילי או נירוסטה בהתקנה שטוחה",
    "spec26": "ברז נשלף במטבח",
    "spec27": "ארונות מטבח כולל יחידות I.B. עם מנגנוני טריקה שקטה",
    "spec28": "חיבור לנקודת מים למקרר",
    "spec29": "חיפוי קירות גרניט פורצלן עד גובה תקרה בחדרי הרחצה - במבחר גוונים",
    "spec30": "ארונות אמבטיה מעוצבים עם כיור אינטגרלי בכל חדרי הרחצה",
    "spec31": "אסלות תלויות עם מנגנון הדחה סמוי",
    "spec32": "אינטרפוץ 4 דרך בחדר רחצה כללי"
  },
  "specsShviro": {
    "category1": {
      "title": "הבניין",
      "spec1": "חיפוי הבניין באבן יוקרתית על פי בחירת האדריכל",
      "spec2": "לובי כניסה יוקרתי המשלב תאורה ייחודית המעוצב ע\"י אדריכל החברה",
      "spec3": "לובי קומתי מפואר הכולל חיפויים ייחודים ורצפה יוקרתית",
      "spec4": "מעלית בעיצוב חדשני בכניסה לבניין",
      "spec5": "פיתוח המגרש כולל גינון יוקרתי ומעוצב",
      "spec6": "חניון תת קרקעי רחב ידיים לרווחת הדיירים",
      "spec7": "מועדון דיירים יוקרתי ומעוצב לרווחת הדיירים",
      "spec8": "חדר עגלות/ אופניים"
    },
    "category2": {
      "title": "הדירה",
      "spec1": "ריצוף גרניט פורצלן במידות 80/80 למעט חדרים רטובים",
      "spec2": "חלונות אלומיניום איכותיים ומודרניים",
      "spec3": "מערכת מיזוג אוויר הכוללת הנמכת גבס והתקנת מזגן בדירה עפ\"י יועץ מיזוג אוויר",
      "spec4": "תריסים חשמליים בסלון וחדרי השינה (למעט ממ\"ד)",
      "spec5": "ברזי פרח מעוצבים",
      "spec6": "נקודות טלוויזיה וטלפון בכל חדר",
      "spec7": "שקעים ומפסקים מסוג גוויס או ש\"ע",
      "spec8": "מפסק תאורה מחליף בחדר הורים ובמסדרון",
      "spec9": "חשמל תלת פאזי 25*3"
    },
    "category3": {
      "title": "מטבח",
      "spec1": "ארונות מטבח עליונים ותחתונים כולל יחידות \"בילד- אין\"",
      "spec2": "משטחי עבודה אבן קיסר או שוו\"ע – מספר גוונים לבחירת הלקוח",
      "spec3": "הכנה לנקודת מים במקרר",
      "spec4": "הכנה למדיח כלים",
      "spec5": "הכנה לכיריים חשמליות"
    },
    "category4": {
      "title": "חדרי רחצה",
      "spec1": "חיפוי קירות וריצוף בחדרי האמבטיה והשירותים בקרמיקה יוקרתית",
      "spec2": "ארונות אמבטיה תלויים",
      "spec3": "אסלות תלויות בעלות מיכלי הדחה סמויים בכל חדרי השירותים והאמבטיה",
      "spec4": "אינטרפוץ 4 דרך במקלחת הורים או במקלחת מתבגר כולל ראש גשם ומזלף",
      "spec5": "סוללה באמבטיה כללית כולל אביק",
      "spec6": "אמבטיה אקרילית בגוון לבן",
      "spec7": "הכנה לתנור חימום חשמלי בחדרי רחצה"
    },
    "category5": {
      "title": "מרפסת שמש",
      "spec1": "נקודת מים וגז במרפסת שמש",
      "spec2": "ריצוף נגד החלקה גרניט פורצלן דמוי פרקט",
      "spec3": "מעקה דקורטיבי זכוכית משולב אלומיניום",
      "spec4": "שקע חשמל מוגן מים"
    },
    "category6": {
      "title": "דירות פנטהאוז",
      "spec1": "ריצוף גרניט פורצלן במידות 100/100 או 60/120"
    }
  },
  "specsHolon": {
    "spec1": "בלב שכונת נווה ארזים המתחדשת, נבנה מגדל NEW LIFE  פרויקט מגורים ייחודי המביא עימו בשורה חדשה של איכות חיים, עיצוב מוקפד וסטנדרט מגורים גבוה.",
    "spec2": "בפרויקט תכנון אדריכלי חדשני מבית יונתן שטיין אדריכלים, המשלב באופן המושלם מרחב, פרטיות ופונקציונליות.",
    "spec3": "המגדל, בן 9 הקומות, ממוקם ברחוב ירמיהו 3 ומציע תמהיל דירות מגוון הכולל דירות 3-5 חדרים, דירות גן ופנטהאוזים מרהיבים, כך שכל שנותר לכם הוא לבחור את בית חלומותיכם.",
    "spec4": "לגור בסטנדרט אחר – ליהנות מהיתרונות הייחודיים של הפרויקט:",
    "spec5": "נוף פתוח מהקומה הראשונה",
    "spec6": "חניון תת-קרקעי עם עמדות טעינה לרכבים חשמליים",
    "spec7": "תכנון מודרני וחלונות ענק - מהתקרה ועד הרצפה, לאור טבעי ותחושת מרחב",
    "spec8": "מפרט עשיר",
    "spec9": "כל זאת לצד נגישות מרבית אל צירי תנועה מרכזיים, תחבורה ציבורית ותחנות הקו הירוק של הרכבת הקלה, ועם הכל קרוב לבית: פארקים, אזורי תעסוקה, מרכזי קניות ומוסדות חינוך איכותיים במרחק"
  },
  "specsHavatzelet": {
    "category1": {
      "title": "בניין ופיתוח סביבתי",
      "spec1": "לובי כניסה בעיצוב אדריכלי",
      "spec2": "נורות \"לד\" חסכוניות בלובי ובמבואות",
      "spec3": "פיתוח שטח וגינון בתכנון אדריכל נוף בשילוב תאורה היקפית מעוצבת",
      "spec4": "חניה פרטית לכל דירה בחניון תת קרקעי",
      "spec5": "מחסן לדירות נבחרות בלבד",
      "spec6": "מעליות מהירות בשילוב נירוסטה ומראות",
      "spec7": "בניה ירוקה לפי תקן 5281",
      "spec8": "הכנה למערכת הטענה לרכבים חשמליים על פי תקן",
      "spec9": "חניון תת קרקעי רחב ידיים"
    },
    "category2": {
      "title": "בדירה",
      "spec1": "דלת כניסה מעוצבת רב בריח או ש\"ע",
      "spec2": "דלתות פנים מהודרות מסדרת \"למינטו\" חברת פנדור או ש\"ע",
      "spec3": "מערכת מיזוג אוויר מיני מרכזית",
      "spec4": "חלונות אלומיניום איכותיים \"טריפלקס\" / בידודית",
      "spec5": "תריסי גלילה חשמליים בסלון וחדרי השינה",
      "spec6": "ריצוף גרניט פורצלן במידות 1.00/1.00 במגוון צבעים לבחירה בסלון וחדרי שינה",
      "spec7": "מערכת חשמל בית חכם לשליטה בחלל המגורים על תאורה, תריס חשמלי, דוד חשמלי ומיזוג אוויר",
      "spec8": "חשמל תלת פאזי 3X25",
      "spec9": "נק' טלפון, TV ומחשב בכל חדר",
      "spec10": "מסך צבעוני בקוטר \"7 למערכת אינטרקום ביחידת המגורים ושלוחה ביחידת הורים",
      "spec11": "מעקות זכוכית במרפסות",
      "spec12": "נקודת מים וחשמל במרפסות"
    },
    "category3": {
      "title": "מטבח",
      "spec1": "ארונות מטבח כולל יחידת I.B עם מנגנוני טריקה שקטה",
      "spec2": "משטח עבודה אבן קיסר או שוו\"ע במבחר דגמים וגוונים לבחירה",
      "spec3": "כיור מטבח אקרילי או נירוסטה בהתקנה שטוחה",
      "spec4": "ברז נשלף במטבח",
      "spec5": "חיפוי קרמיקה - במבחר דגמים וגוונים לבחירה",
      "spec6": "חיבור לנקודת מים למקרר"
    },
    "category4": {
      "title": "חדרי רחצה",
      "spec1": "ריצוף וחיפוי חדרי רחצה בקרמיקה/ גרניט פורצלן במגוון גוונים וגדלים",
      "spec2": "ארון כיור ומראה בחדר אמבטיה ובחדר רחצה הורים",
      "spec3": "ברזי רחצה מעוצבים \"גרואה\" או שו\"ע",
      "spec4": "אסלות תלויות עם מכלי הדחה סמויים בכל חדרי הרחצה והשירותים",
      "spec5": "ארון אמבטיה אינטגרלי כולל מראה משולבת בכל חדרי הרחצה",
      "spec6": "אמבטיה אקרילית עם אינטרפוץ 4 דרך כולל מילוי אוטומטי ונקודת מים עם מוט ומזלף"
    }
  },
  "specsYuvalim": {
    "category1": {
      "title": "בניין, חניון ופיתוח",
      "spec1": "מבנים מעוצבים הכוללים שילוב מספר סוגים של חיפויי חוץ",
      "spec2": "לובי גבוה בעיצוב מושקע ע\"י מעצבת פנים",
      "spec3": "חדר עגלות/אופניים",
      "spec4": "מעליות מהירות מחברות מובילות",
      "spec5": "חניון תת קרקעי בגימור של צבע אפוקסי ברצפה",
      "spec6": "גינון ופיתוח עשיר מתוכנן על ידי אדריכל נוף",
      "spec7": "חדר דיירים מאובזר",
      "spec8": "מחסן לכל דירה"
    },
    "category2": {
      "title": "מערכות אלומיניום ודלתות",
      "spec1": "דלת כניסה בטחון דקורטיבית ואיכותית",
      "spec2": "דלתות פנים איכותיות תוצרת פנדור או שוו\"ע",
      "spec3": "חלונות אלומיניום איכותיים בזיגוג כפול",
      "spec4": "תריסי גלילה חשמליים"
    },
    "category3": {
      "title": "ריצוף וחיפוי קירות",
      "spec1": "ריצוף הדירה - מבחר עשיר של דוגמאות מקולקציה מודרנית",
      "spec2": "ריצוף הדירה (למעט חדרי רחצה ומרפסות) - גרניט פורצלן במידות גדולות כ- 100x100",
      "spec3": "ריצוף וחיפוי חדרי רחצה - גרניט פורצלן במגוון דגמים ומידות כדוגמת 30/60, 25/70",
      "spec4": "שילוב אריח דקור בחיפוי חדרי רחצה"
    },
    "category4": {
      "title": "סידורים סניטריים",
      "spec1": "אינטרפוץ 4 דרך במקלחת/אמבטיה, כולל מזלף וראש גשם קבוע/פיית מילוי",
      "spec2": "ברזים מעוצבים מסדרות איכותיות כולל תוצרת חוץ",
      "spec3": "אסלה תלויה עם מיכל הדחה סמוי",
      "spec4": "ארון מעוצב הכולל כיור ומשטח אינטגרלי בחדרי הרחצה",
      "spec5": "כיור מטבח נירוסטה, אקרילי או גרניט בהתקנה שטוחה",
      "spec6": "אמבטיה אקרילית",
      "spec7": "מחשב השקייה עבור דירות שבהן קיימות אדניות צמודות למרפסות"
    },
    "category5": {
      "title": "מטבחים",
      "spec1": "מטבח יוקרתי הכולל יחידת בילד אין מבית החברות המובילות",
      "spec2": "שילוב של מגירות בטריקה שקטה",
      "spec3": "משטח עבודה במטבח של אבן קיסר במגוון דגמים לבחירה"
    },
    "category6": {
      "title": "חשמל ותקשורת",
      "spec1": "מערכת בית חכם אלחוטית",
      "spec2": "חיבור חשמל דירתי תלת פאזי",
      "spec3": "נקודת טלפון וטלוויזיה בכל חדר",
      "spec4": "הכנה לרמקולים בסלון",
      "spec5": "אינטרקום עם מסך צבעוני בכניסה לדירה",
      "spec6": "אביזרי חשמל איכותיים כדוגמת גוויס/ביטוצ'ינו/ניסקו",
      "spec7": "הכנה לנקודת מחשב לכל חדר",
      "spec8": "אספקה והתקנה מלאה של מערכת מיזוג אויר דירתית"
    }
  },
  "specsRassco": {
    "category1": {
      "title": "מפרט הדירות",
      "spec1": "דלתות פנים מדגם \"יוניק\" של חברת פנדור במבחר גוונים לבחירה או שו\"ע",
      "spec2": "דלת ביטחון מעוצבת בכניסה לדירה",
      "spec3": "ריצוף גרניט פורצלן 80*80 במגוון רחב של דגמים וגוונים לבחירה, 5 חדרים 100*100",
      "spec4": "חלונות אלומיניום בזיגוג בידודית או טריפלקס בחדרי שינה וויטרינה סלון, בממ\"ד זכוכית עפ\"י תקן",
      "spec5": "דוד מים חשמלי בנפח 150 ליטר",
      "spec6": "הכנה לרשתות בחלונות (למעט בחלונות קיפ ובממ\"ד)",
      "spec7": "מגוון חיפויים וריצופים לבחירה"
    },
    "category2": {
      "title": "חדרי רחצה ושירותים",
      "spec1": "אינטרפוץ במקלחת ובאמבטיה",
      "spec2": "ארון אמבטיה עם כיור אינטגרלי בחדר רחצה ראשי",
      "spec3": "ריצוף מונע החלקה וחיפוי קירות באריחי גרניט פורצלן במבחר גוונים ודגמים לבחירה",
      "spec4": "אסלות תלויות ומכלי הדחה סמויים",
      "spec5": "כלים סניטרים וברזים איכותיים"
    },
    "category3": {
      "title": "מטבח",
      "spec1": "מטבח מעוצב הכולל קלפה עליונה, ארונות תחתונים ויחידת BI (בהתאם לתכנון האדריכל)",
      "spec2": "טריקה שקטה במגירות",
      "spec3": "כיור בהתקנה שטוחה",
      "spec4": "משטח עבודה איכותי מסוג אבן קיסר במבחר גוונים לבחירה",
      "spec5": "ברז נשלף איכותי",
      "spec6": "הכנה למדיח כלים"
    },
    "category4": {
      "title": "מרפסת שמש גדולה ומרווחת",
      "spec1": "נקודת מים",
      "spec2": "נקודת חשמל"
    },
    "category5": {
      "title": "מערכות חשמל",
      "spec1": "תריסי גלילה חשמליים בסלון ובחדרים (פרט לממ\"ד)",
      "spec2": "אביזרי חשמל יוקרתיים מתוצרת גויס/בטוצ'ינו או ש\"ע",
      "spec3": "הכנה למיזוג דירתי",
      "spec4": "לובי כניסה מפואר בעיצוב של מעצב פנים",
      "spec5": "מעליות מהירות ומפוארות, אחת המעליות תשמש כמעלית שבת"
    },
    "category6": {
      "title": "במתחם",
      "spec1": "חניות מקורות תת קרקעיות"
    }
  },
  "introScreen": {
    "text1": "לגור במרחק נגיעה מהטיילת ומרצועת החוף המרהיבה",
    "text2": "בואו לגדול ולחיות במרחק נגיעה מהטבע ומאיכות החיים הירוקה",
    "text3": "שכונת העתיד של הצפון כבר כאן!"
  },
  "scheduling": {
    "appointment": {
      "bookOnlineTour": "קבעו פגישה",
      "editAppointment": "ערוך פגישה",
      "selectDateTimePrompt": "אנא בחרו את התאריך והשעה המתאימים לכם לפגישה עם נציג",
      "selectDateTimePromptLanding": "אנא בחרו את התאריך והשעה המתאימים לכם לפגישה עם נציג",
      "selectDateTimePromptLandingStep1": "אנא בחרו את התאריך והשעה המתאימים לכם לפגישה עם נציג",
      "selectDateTimePromptLandingStep2": "אנא הזינו את פרטי הקשר שלכם",
      "selectDateTimePromptStep1": "בחרו את תאריך ושעת הפגישה",
      "selectDateTimePromptStep2": "הזינו את פרטי הלקוח עמו תפגשו",
      "selectProject": "בחרו פרויקט",
      "selectProjectPlaceholder": "בחר פרויקט עבור הפגישה הזו",
      "projectRequired": "בחירת פרויקט נדרשת",
      "selectDate": "בחרו תאריך",
      "selectTime": "בחרו שעה",
      "noAvailableDates": "לא זמין תאריך מתאים",
      "noAvailableTimeSlots": "אין משבצות זמן זמינות לתאריך זה",
      "duration": "משך",
      "duration30Min": "30 דקות",
      "duration1Hour": "שעה אחת",
      "duration1_5Hours": "שעה וחצי",
      "duration2Hours": "שעתיים",
      "appointmentType": "סוג פגישה",
      "googleMeet": "Google Meet",
      "physicalMeeting": "פגישה פיזית",
      "notes": "הערות",
      "notesPlaceholder": "מידע נוסף על הפגישה",
      "continue": "הבא",
      "continueLanding": "הבא",
      "continueStep3": "המשך",
      "name": "שם",
      "namePlaceholder": "שם",
      "phone": "טלפון",
      "phonePlaceholder": "טלפון",
      "email": "דוא\"ל",
      "emailPlaceholder": "דוא\"ל",
      "bookAppointment": "קביעת פגישה",
      "bookAppointmentLanding": "קביעת פגישה",
      "updateAppointment": "עדכן פגישה",
      "creating": "יוצר פגישה...",
      "updating": "מעדכן פגישה...",
      "updateSuccess": "הפגישה עודכנה בהצלחה!",
      "updateError": "עדכון הפגישה נכשל. אנא נסה שוב.",
      "meetingSet": " הפגישה נקבעה בהצלחה!",
      "invitationSent": "ההזמנה לפגישה נשלחה אליכם לתיבת הדוא\"ל",
      "appointmentWith": "פגישה עם",
      "minutes": "דקות",
      "hour": "שעה",
      "hours": "שעות",
      "senderInformationWarning": "התראות דוא\"ל לא יישלחו ללקוחות כיוון שפרטי השולח לא הושלמו. אנא הגדר שם שולח, דוא\"ל וכתובת מענה בהגדרות דוא\"ל.",
      "goToEmailSettings": "עבור להגדרות דוא\"ל",
      "validation": {
        "nameRequired": "שם נדרש",
        "nameMinLength": "השם חייב להכיל לפחות 2 תווים",
        "nameMaxLength": "השם חייב להכיל בין 2-100 תווים",
        "emailRequired": "דוא\"ל נדרש",
        "emailInvalid": "אנא הזן כתובת דוא\"ל תקינה",
        "phoneRequired": "מספר טלפון נדרש",
        "phoneInvalid": "אנא הזן מספר טלפון תקין"
      },
      "errors": {
        "validation": {
          "nameLength": "השם חייב להכיל בין 2-100 תווים",
          "emailRequired": "נדרש דוא\"ל תקין",
          "phoneInvalid": "פורמט מספר טלפון לא תקין",
          "timeSlotNotFound": "משבצת הזמן שנבחרה לא נמצאה",
          "futureDate": "הפגישה חייבת להיות מתוזמנת לתאריך עתידי",
          "allFieldsRequired": "אנא מלא את כל השדות הנדרשים בצורה נכונה"
        },
        "booking": {
          "failed": "הזמנת הפגישה נכשלה. אנא נסה שוב.",
          "timeSlotUnavailable": "משבצת הזמן הזו אינה זמינה יותר. אנא בחר זמן אחר."
        },
        "network": {
          "connectionError": "שגיאת רשת. אנא בדוק את החיבור שלך ונסה שוב."
        }
      }
    },
    "appointmentDescription": {
      "contactInformation": "פרטי יצירת קשר",
      "name": "שם",
      "email": "דוא\"ל",
      "phone": "טלפון",
      "meetingType": "סוג פגישה",
      "duration": "משך",
      "minutes": "דקות",
      "notes": "הערות",
      "googleMeet": "Google Meet",
      "physicalMeeting": "פגישה פיזית"
    },
    "noProjectsFound": "לא נמצאו פרויקטים"
  },
  "projectListingFeatures": {
    "parking": "חניה",
    "storage": "מחסן",
    "ac": "מיזוג",
    "elevator": "מעלית",
    "shelter": "ממ״ד",
    "balcony": "מרפסת",
    "windowBars": "סורגים",
    "wheelchair": "גישה לנכים",
    "furnished": "מרוהטת",
    "exclusive": "בבלעדיות"
  }
}
